import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormGroupDirective } from '@angular/forms';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { CodeEnforcementService } from '../code-enforcement.service';
import { CaseListingComponent } from '../case/case-listing/case-listing.component';
import { ActivatedRoute, Router } from '@angular/router';




@Component({
  selector: 'app-address-search',
  templateUrl: './case-search.component.html',
  styleUrls: ['./case-search.component.scss']
})
export class AddressSearchComponent implements OnInit {
  searchForm: FormGroup;
  public streets: any;
  public caseData = [];
  // public columnNames = {
  //   'caseId': 'Case Id',
  //   'date': 'Date/Time',
  //   'Violation': 'Violation',
  //   'user': 'User',
  //   'daysCure': 'Days to Cure',
  //   'category': 'Category',
  //   'status': 'Status',
  // };
  public showSpinner: boolean = false;
  public selectedAddress;
  public isAddressSearch: boolean = false;
  @ViewChild(CaseListingComponent, { static: false }) tableComp: CaseListingComponent;



  constructor(private formBuilder: FormBuilder,
    private vovSharedService: vovSharedService,
    private codeEnforcementService: CodeEnforcementService,
    private router: Router,
    private activeRouter: ActivatedRoute,) { }

  ngOnInit(): void {
    this.searchForm = this.formBuilder.group({
      streetNo: ['', Validators.required],
      streetId: ['', Validators.required],
      caseId: ['', Validators.required],
    });

    this.activeRouter.params.subscribe(params => {
      this.isAddressSearch = params.isAddress == "true" ? true : false;
      console.log(this.isAddressSearch, 'add')
      if (this.isAddressSearch) {
        this.searchForm.controls["caseId"].clearValidators();
        this.searchForm.controls["caseId"].updateValueAndValidity();
      } else {
        this.searchForm.controls["streetId"].clearValidators();
        this.searchForm.controls["streetId"].updateValueAndValidity();
        this.searchForm.controls["streetNo"].clearValidators();
        this.searchForm.controls["streetNo"].updateValueAndValidity();
      }
    });


    this.vovSharedService.fetchAllStreets().subscribe((res) => {
      this.streets = res.streetsList;
      this.streets.sort((a, b) => a.street.localeCompare(b.street));
    });
    if (this.isAddressSearch) {
      this.searchForm.get('streetId').valueChanges.subscribe(address => {
        console.log(address)
        this.selectedAddress = this.streets.find(street => street.id == address);
        console.log(this.selectedAddress, 'áddr')
      })
    }

  }

  onSubmitSearch() {
    console.log('hhh')
    this.showSpinner = true;
    this.codeEnforcementService.fetchAllCasesbyFilters(this.searchForm.value).subscribe(res => {
      console.log(res, 'ress')
      this.showSpinner = false;
      let cases = [];
      if (res.casesList.length > 0) {
        res.casesList.map((data: any) => {
          let caseData = {
            'CaseId': data.id,
            'Date': data.date,
            'Violation': (data && data.violation) ? data.violation.violation : null,
            'User': (data && data.user) ? data.user.userName : null,
            'DaystoCure': (data && data.daysToCure) ? data.daysToCure.numberOfDays : null,
            'Category': (data && data.category) ? data.category.category : null,
            'Status': (data && data.caseStatus) ? data.caseStatus.status : null,
            'StreetNo': data.streetNo,
            'Street': (data && data.streets) ? data.streets.street : null,
          }
          cases.push(caseData);
        })
      }
      this.caseData = cases;
      console.log(this.caseData, 'address tabelee')
    })
    this.tableRendering();

  }

  tableRendering() {
    console.log('inside table rendering')
    if (this.tableComp != undefined) {
      console.log('inside if rendering')
      this.tableComp.renderTable();
    }
  }

}
